import { Avatar, Button, Flex, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  BankOutlined,
  CreditCardOutlined,
  FileProtectOutlined,
  IdcardOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import { Organization } from '@models/organization';
import useMobile from '../../hooks/useMobile';
import { OrganizationType } from '../../constants/orgType';
import { useAuth } from '../../hooks/useAuth';

export type Props = {
  organization: Organization;
};
export const OrganizationDetailPanel = (props: Props) => {
  const { organization } = props;
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useMobile();
  const auth = useAuth();

  return (
    <Flex
      vertical
      align="center"
      gap={isMobile() ? 'small' : 'large'}
      justify="start"
    >
      <Avatar
        size={{
          xs: 60,
          sm: 60,
          md: 80,
          lg: 80,
          xl: 80,
          xxl: 80,
        }}
        icon={<BankOutlined />}
      />
      <Typography.Text
        style={{ fontSize: 20, fontWeight: 'bold' }}
      >{`${organization.name}`}</Typography.Text>
      <Flex vertical align="center">
        <Row style={{ color: 'gray' }}>
          <IdcardOutlined />
          <Typography.Text
            style={{ marginLeft: 10 }}
          >{`${OrganizationType.getByKey(organization.type).getLabel(
            i18n.language,
          )}`}</Typography.Text>
        </Row>
        <Row style={{ color: 'gray' }}>
          <TeamOutlined />
          <Typography.Text style={{ marginLeft: 10 }}>
            {t('org.registeredPatients', {
              count: organization.patients?.length ?? 0,
            })}
          </Typography.Text>
        </Row>
      </Flex>

      <Flex
        vertical
        gap="small"
        align="center"
        style={{ width: '100%', marginTop: isMobile() ? 4 : 8 }}
      >
        <Button
          shape="round"
          type="default"
          block
          icon={<FileProtectOutlined />}
          onClick={() => navigate('/care-protocols')}
        >
          {t('menu.careProtocols')}
        </Button>
        <Button
          shape="round"
          type="default"
          block
          icon={<CreditCardOutlined />}
          onClick={() => navigate('/plan')}
        >
          {t('menu.plan')}
        </Button>
        {auth.isOwner() && (
          <Button
            shape="round"
            type="default"
            block
            icon={<UsergroupAddOutlined />}
            onClick={() => navigate('/members')}
          >
            {t('menu.members')}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
